import { StyleSheet, Dimensions } from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import "../../../../../src/App.scss";

const actualWidth = Dimensions.get("screen").width;
const actualHeight = Dimensions.get("screen").height;

const getSheet = (show) => {
  return StyleSheet.create({
    body: {
      flex: 1,
      // backgroundColor: "#eeeeee",
      height: "100vh",
      width: "100vw",
      overflow: "auto",
    },

    topborder: {
      position: "relative",
      alignSelf: "center",
      borderColor: "var(--module-color-la)",
      borderTopWidth: 3,
      marginBottom: hp("1.2%"),
    },
    Image: {
      position: "relative",
      alignSelf: "flex-end",
      width: 48,
      height: 12,
      marginRight: 7,
      color: "var(--module-color-la)",
      fontSize: 17,
      fontWeight: "var(--font-weight-bold)",
    },

    headingContainer: {
      width: actualWidth < 600 ? "321px" : "534px",
      height: "auto",
      justifyContent: "space-between",
      alignItems: "center",
      alignSelf: "center",
      marginBottom: "2%",
    },

    Line1: {
      position: "relative",
      width: actualWidth < 600 ? 250 : 400,
      height: 1,
      backgroundColor: "#d4d4d4",
      alignSelf: "center",
    },

    Line2: {
      position: "relative",
      width: actualWidth < 600 ? 250 : 400,
      height: 1,
      backgroundColor: "#d4d4d4",
      alignSelf: "center",
    },

    header: {
      position: "relative",
      width: "100%",
      alignSelf: "center",
      fontWeight: "var(--font-weight-light)",
      fontSize: actualWidth <= 320 ? 30 : 48,
      letterSpacing: 2.8,
      textAlignVertical: "center",
      textAlign: "center",
      color: "var(--text-color-default)",
      textTransform: "capitalize",
      marginTop: 15,
      marginBottom: 8,
    },

    headingTxtPos: {
      position: "relative",
      top: actualHeight < 768 ? 20 : actualHeight <= 1024 ? 20 : 30,
    },
    headingTxt: {
      position: "relative",
      fontWeight: "var(--font-weight-thin)",
      fontSize: actualWidth <= 400 ? 24 : 32,
      alignSelf: "center",
      top: 30,
      height: "auto",
      color: "var(--text-color-default)",
    },

    topView: {
      height: "auto",
      // bottom: (actualHeight < 768) ? '7%' : (actualHeight <= 1024 ? '7%' : '0%'),
    },

    bottomView: {
      justifyContent: "space-between",
      alignItems: "center",
      // height: hp('15%'),
      // bottom: actualWidth > 500 ? (actualHeight < 768 ? '17%' : (actualHeight <= 1024 ? '0%' : '17%')) : '-22%',
    },

    nextTextStyle: {
      color: "var(--text-color-default)",
      fontSize: actualWidth <= 320 ? 25 : 32,
      fontWeight: "var(--font-weight-light)",
      fontStyle: "normal",
      position: "relative",
      alignSelf: "center",
      textAlign: "center",
      letterSpacing: 2.4,
      // top: actualHeight < 768 ? '-120%' : (actualHeight <= 1024 ? '-20%' : '90%'),
    },

    button: {
      height: 48,
      width: 90,
      backgroundColor: "var(--text-color-default)",
      // borderRadius: (48 + 68) / 2,
      paddingVertical:
        actualWidth === 1600
          ? 17
          : actualWidth === 1920
          ? 18
          : actualWidth === 2560
          ? 16
          : actualWidth === 3840
          ? 17
          : actualWidth === 4096
          ? 17
          : actualWidth === 4500
          ? 17
          : actualWidth === 5120
          ? 16
          : actualWidth === 6400
          ? 16
          : actualWidth === 7680
          ? 16
          : actualWidth === 1024
          ? 16
          : 16, //2.1 / 16
      position: "relative",
      alignSelf: "center",
      marginHorizontal: wp("1%"),
    },
    buttonText: {
      color: "#ffffff",
      fontSize: 20,
      textAlign: "center",
      fontWeight: "var(--font-weight-bold)",
      letterSpacing: 2,
    },
    backButtonText: {
      color: "var(--text-color-default)",
      fontSize: hp("2.9%"),
      textAlign: "center",
      fontWeight: "var(--font-weight-bold)",
    },
    backButton: {
      height: hp("6%"),
      width: wp("23%"),
      borderWidth: 1,
      borderRadius: wp("0.7%"),
      borderColor: "var(--text-color-default)",
      borderStyle: "solid",
      backgroundColor: "transparent",
      paddingVertical:
        actualHeight > 640
          ? actualHeight > 980
            ? hp("1%")
            : hp("1.3%")
          : hp("0.8%"),
      position: "relative",
      alignSelf: "center",
    },
    rowBox: {
      flexDirection: "row",
      justifyContent: "center",
      alignSelf: "center",
      position: "relative",
      height: actualHeight <= 568 ? hp("13.5%") : hp("7%"),
      transform: actualWidth <= 320 ? [{ scale: 0.9 }] : [{ scale: 1 }],
      width: wp("100%"),
      // top: actualHeight < 768 ? '-100%' : (actualHeight <= 1024 ? '0%' : '100%')//13
    },
  });
};

export default getSheet;
